const spiideoCompetitorMappingsTableColumns = {
    sport: {
        label: 'Sport',
        sorting: (row) => row.competitor?.sport?.name ?? '',
    },
    tournament_category: {
        label: 'Category',
        sorting: (row) => row.competitor?.tournament_category?.name ?? '',
    },
    competitor: {
        label: 'Competitor',
        sorting: (row) => row.competitor?.name ?? '',
    },
    spiideo_team_uuid: {
        label: 'Spiideo team UUID',
        sorting: (row) => row.spiideo_team_uuid ?? '',
    },
    sportradar_srt_url: {
        label: 'Sportradar SRT URL',
        sorting: (row) => row.sportradar_srt_url ?? '',
    },
    ligr_srt_url: {
        label: 'LIGR SRT URL',
        sorting: (row) => row.ligr_srt_url ?? '',
    },
    actions: {
        label: 'Actions',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
        },
    },
};

export default spiideoCompetitorMappingsTableColumns;
